import { Amplify } from 'aws-amplify';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_iFZ7SFgwB',
      userPoolClientId: '4193nsnq6lpdo54ucc50r0bd72',
      // Optional: only if/when you want to customize this
      // loginWith: {
      //   email: true,
      // },
    },
  },
};

Amplify.configure(awsConfig);

export default awsConfig;
